// extracted by mini-css-extract-plugin
export default {"main":"TableTh_main__qfLqB","text":"TableTh_text__zl1k5"};